<template lang="pug">
// 弹出框查看
el-dialog(:title='dialogTitle', :visible.sync='showDia', width='600px',:append-to-body="false",:modal-append-to-body="false" ,@close="closeDialog" )
    el-form(ref='form', :model='rowdata', label-width='110px') 

        el-form-item(label='发布方式: ')
            el-checkbox-group( v-model="rowdata.publishPlatform")
                el-checkbox(label='1') 短信
                el-checkbox(label='2') 微信
                
        el-form-item(label='内容:', prop='results', style='margin-top: 10px;margin-bottom: 150px')
            quillEditor(v-model='rowdata.results', :options='editorOption', style='height:150px')
    .boontbtn
        el-button(type='primary', size='small', style='margin: 0 30px', @click='sendMessagedata') 保存
        el-button(type='info', size='small', @click='closeDialog') 关闭

</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import editor_option from "../../../../utils/editorOption.js";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "sendMessage",
  props: ["fatherdata", "show", "rowid"],
  components: { quillEditor },
  data() {
    return {
      editorOption: editor_option.editorOption,
      dialogTitle: "发送短信",
      showDia: false,
      rowdata: {
        publishPlatform: []
      }
    };
  },
  methods: {
    //审批接口
    async sendMessagedata() {},
    closeDialog() {
      this.showDia = false;
      this.$emit("func", []);
    }
  },
  mounted() {},
  watch: {
    show(val) {
      this.showDia = val;
    }
  },
  beforeDestroy() {}
};
</script>
 